import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({

  errorTitle: {
    id: 'authoring.texteditor.selectimagemodal.error.errorTitle',
    defaultMessage: 'Error',
    description: 'Title of message presented to user when something goes wrong',
  },
});

export default messages;
